import { searchModules } from '@/api/module';
import moment from 'moment';
import { formatTimeStr } from './other';

type IModuleInfo = IModule.IResponse.IModuleInfo;

export let userAllModule: IModuleInfo[] = [];

export const getUserAllModule = () => {
  return new Promise((resolve, reject) => {
    searchModules({
      pagesize: 50,
    }).then((res) => {
      userAllModule = res.data;
      resolve(res.message);
    }).catch((err) => {
      reject(err.message);
    });
  });
};

export const getModules = (
  params: IModule.IRequest.ISearchModules,
): Promise<IModule.IResponse.IData> => {
  return new Promise((reslove, reject) => {
    searchModules(params).then((res) => {
      reslove(res);
    }).catch((error) => {
      reject(error.message);
    });
  });
};

interface IClassifyModuleList {
  listByToday: IModuleInfo[];
  listByOther: IModuleInfo[];
}
export const classifyModuleList = (data: IModuleInfo[]): IClassifyModuleList => {
  const today = moment().format('YYYY-MM-DD');
  const result: IClassifyModuleList = {
    listByToday: [],
    listByOther: [],
  };
  data.forEach((moduleItem) => {
    if (formatTimeStr(moduleItem.due) === today) {
      result.listByToday.push(moduleItem);
    } else {
      result.listByOther.push(moduleItem);
    }
  });
  return result;
};

